<template>
    <div class="pane">
        <!-- 标题 完稿文件-->
        <div class="title-box">
            <h2 class="title">完稿文件</h2>
        </div>

        <div class="model-box">
            <div class="file-list" v-if="dataSource.status > 2">
                    <div class="value-box" v-for='item of fileList' :key="item.id">
                        <!-- <svg-icon icon-class="xlsx" class="icon" /> -->
                        <div :style="{'background-image': 'url(' + item.thumbnailImageUrl + ')'}" class="thumbnailImageClass" @click="downloadUrlFun(item.id)"></div>

                        <span class="title" @click='rowClick(item)'>{{item.fileName}}</span>
                        
                        <el-button type="text" style="color:#3a89ff;padding:0 10px;line-height:20px" @click="downloadUrlFun(item.id)">下载</el-button>
                    </div>
            </div>
            <!-- 当为甲方时 -->
            <div v-else-if="accessPoint['mineuser']" style="display: flex;flex-flow: row nowrap;justify-self: flex-start;align-items: flex-start;font-size: 14px;line-height: 20px;margin-bottom: 12px;">
                待乙方上传
            </div>
            <!-- 当为乙方时 -->
            <div v-else-if="accessPoint['outuser']" >
                待上传
            </div>
            
        </div>

        <!-- 分隔线 -->
        <div class="line" v-if="flowList.length >0"></div>
        <template v-if="flowList.length >0">
            <!-- 标题 修改意见-->
            <div class="title-box">
                <h2 class="title">修改意见</h2>
            </div>
            <div >
                <div v-for="(item,index) in flowList" :key="index" style="margin-bottom:30px;">
                    <div style="margin-bottom:12px;font-size:14px;color:#666">{{item.userName}}({{item.logTime}})</div>

                    <div v-html="item.statusStr" style="margin-left:40px"></div>

                </div>

            </div>
        </template>


        <div class="line" v-if="evaluateList.length > 0 && dataSource.status !== 3"></div>

        <template v-if="evaluateList.length > 0 && dataSource.status !== 3">
            <!-- 标题 点评-->
            <div class="title-box">
                <h2 class="title">点评</h2>
            </div>

            <div class="model-box">
                <div class="value" v-if="false">待发起人点评</div>
                <div class="item-box all" v-for="(item,index) of evaluateList" :key="index" >
                    <div class="label">{{item.name}}</div>
                    <!-- <el-rate v-model="item.score" disabled disabled-void-color="#CCCCC"></el-rate> -->
                    <el-rate v-model="item.score" disabled></el-rate>
                </div>
            </div>
        </template>

        

         <!-- 修改意见弹框意见 width="400px"-->
        <el-dialog :title="dialogFlag === 'update'?'修改意见':'评价'" :visible.sync="dialogVisible" v-if="dialogVisible" :append-to-body="true" class="opinionDialog">
            <el-form ref="ruleForm" :model="dialogForm" :rules="rulesForm">
                <el-form-item  prop="opinion" v-if="dialogFlag === 'update'">
                    <div class="model-box">
                        <markdown-editor  v-model="dialogForm.opinion" mode="wysiwyg" language="zh-CN" height="240px" style="width:100%;" />
                    </div>
                </el-form-item>
                <el-form-item  prop="evaluate" v-if="dialogFlag === 'sure'">
                    <div class="model-box">
                        <div class="item-box all" v-for="(item,index) of evaluateList" :key="index" >
                            <div class="label">{{item.name}}</div>
                            <el-rate v-model="item.score" ></el-rate>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
              <span slot="footer" >
                  <div style="display:inline-block">
                        <label style="margin-right:6px;font-size:14px;color:#666">通知方式：</label>
                        <el-checkbox v-model="checkedEmail">邮箱</el-checkbox>
                   </div>
                <el-button style="margin-left:50px;" @click="dialogVisible = false">取消</el-button>
                <el-button  type="primary" @click="dialogFun()">确定</el-button>

            </span>
        </el-dialog>

        <!-- 图片预览 -->
        <image-viewer v-if="showViewer" :show-viewer="showViewer" :on-close="closeViewer" :url-list="[bugUrl]" :list-data="detailsData" @download="downloadUrlFun(detailsData.id)" ></image-viewer>
         
         
    </div>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import {outsource_flowModifyStatus} from '@File~/api/outsourcing'
import ImageViewer from '../ImageViewer'
import {fileType} from '@/utils'

export default {
    components:{MarkdownEditor,ImageViewer},
    inject:['reload'],
    props:{
        dataSource:{
            type:Object,
            default:()=>{
                return null
            }
        },
        flowList:{
            type:Array,
            default:()=>{
                return []
            }
        },
    },
    data() {
        return { 
            bugUrl:'',
            showViewer:false,
            detailsData:{},

            accessPoint: this.$store.getters.accessPoint, //权限点
            dialogFlag:'',
            checkedEmail:false,
            //修改意见弹框
            dialogVisible:false,
            dialogForm:{
                opinion:'',
                evaluate:''
            },
            rulesForm:{
                opinion: [{ required: true, message: '请输入修改意见', trigger: 'required' }]
            },
            //确认点评弹框
            evaluateVisible:false,
            evaluateForm:{
                content:''
            },
           

           // 评价 临时
            evaluateList:[],
            fileList:[],

            // 修改意见
            desc:''
        }
    },
     created(){
        this.fileList = JSON.parse(this.dataSource.completeFileDetail)
        if(this.dataSource.comment){
            let tempComment = JSON.parse(this.dataSource.comment)
            this.evaluateList = [];
            let tempTotal = 0
            for(let item in tempComment){
                tempTotal += tempComment[item]
                this.evaluateList.push({name:item,score:tempComment[item]})
            }
            if(tempTotal === 0){
                this.evaluateList = []
            }
        }
        
    },
    methods:{
        isFileType(type){
          return fileType(type);
        },
         // 关闭图片预览
        closeViewer() {
            // console.log('关闭预览===')
            this.showViewer = false
            this.bugUrl = ''
            this.listData = {}
        },
        rowClick(data){
            if(this.isFileType(data.suffixType) === 'picture' && data.loadFileBinaryUrl) { // 图片 显示大图
                this.bugUrl = data.loadFileBinaryUrl
            }else {// 视频、其它
                this.bugUrl = data.thumbnailImageUrl
            }
            this.detailsData = data
            this.showViewer = true;
        },

        openDialog(flag){
            //flag:update/sure
            if(flag === 'sure'){
                this.evaluateList = [{name:'质量',score:null},{name:'守时',score:null},{name:'服务',score:null},{name:'经验',score:null},{name:'性价比',score:null}]
            }
            this.dialogFlag = flag;
            this.dialogVisible = true;

        },
        dialogFun(){
            let that = this
            this.$refs.ruleForm.validate((valid) => {
                if(valid) {
                    let data = {}
                    if(that.dialogFlag === 'update'){
                        data = {
                            id:this.dataSource.id,
                            userId:this.$store.state.user.userId,
                            status:-4,
                            statusStr:this.dialogForm.opinion,
                            noticeType:this.checkedEmail?1:0,
                        }
                    }else if(that.dialogFlag === 'sure'){
                        let tempComment = {}
                        this.evaluateList.map((item)=>{
                            tempComment[item.name] =item.score
                        })
                        data = {
                            id:this.dataSource.id,
                            userId:this.$store.state.user.userId,
                            status:4,
                            comment:JSON.stringify(tempComment),
                            noticeType:this.checkedEmail?1:0,
                        }
                        
                    }
                    outsource_flowModifyStatus(data).then(response => {
                        if(response.code == 1) {
                            this.$message({type:'success',message:'操作成功'})
                            this.reload()
                        }
                    })  
                }
            })
        },
        opinionFun(){
            
            // this.handleFun(-1,this.refuseForm.refuseContent)
        },
       
        downloadUrlFun(id){
             var form = document.createElement('form')
                document.body.appendChild(form)
                form.setAttribute('style','display:none');
                form.setAttribute('method','post');
                form.setAttribute('action',this.$store.getters.downloadUrl);//下载文件的请求路径
                
                // 创建表单里 input 元素
                var tempInput = document.createElement("input");
                tempInput.type = "hidden";
                tempInput.name = 'fileId';
                tempInput.value = id;
                form.appendChild(tempInput);

                var tempInput2 = document.createElement("input");
                tempInput2.type = "hidden";
                tempInput2.name = 'userId';
                tempInput2.value = this.$store.getters.userId;
                form.appendChild(tempInput2);

                form.submit()
                document.body.removeChild(form)
        },
    
    }
}
</script>

<style lang="scss" scoped>
    .model-box{
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;

            .item-box{
                width: 48%;
                display: flex;
                flex-flow: row nowrap;
                justify-self: flex-start;
                align-items: flex-start;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 12px;
            }
            .all{
                width: 100%;
            }
            .label{
                width: 50px;
                display: block;
                margin-right:12px;
                min-width: 112px;
                text-align: right;
                color: #666666;
            }
            .value{
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                p{
                    margin: 0;
                }
            }
    }
    .title{
        cursor: pointer;
        margin-left: 9px;
    }

    .thumbnailImageClass{
        width: 25px;
        height: 25px;
        background-color: white;
        background-size: contain;
        background-repeat: no-repeat;
    }
    .opinionDialog{
        ::v-deep.el-dialog__body{
            padding-bottom: 0;
        }
    }
</style>